import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";

import Login from "./pages/Login";
import Register from "./pages/Register";
import FacilitatorRegister from "./pages/FacilitatorRegister";
import Pending from "./pages/Pending";
import ScholarDashboard from "./pages/ScholarDashboard";
import FacilitatorDashboard from "./pages/FacilitatorDashboard";
import ProgramLeadDashboard from "./pages/ProgramLeadDashboard";
import IdentityStatement from "./pages/IdentityStatement";

function PrivateRoute({ children, allowedRoles }) {
  const { currentUser, userRole, userProfile } = useAuth();
  if (!currentUser) return <Navigate to="/login" />;
  if (userProfile?.status === "pending") return <Navigate to="/pending" />;
  if (userProfile?.status === "rejected") return <Navigate to="/rejected" />;
  if (allowedRoles && !allowedRoles.includes(userRole)) return <Navigate to="/login" />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
  <Route path="/faci" element={<FacilitatorRegister />} />
  
          <Route path="/pending" element={<Pending />} />
          <Route path="/scholar" element={
            <PrivateRoute allowedRoles={["scholar"]}>
              <ScholarDashboard />
            </PrivateRoute>
          } />
          <Route path="/scholar/identity" element={
            <PrivateRoute allowedRoles={["scholar"]}>
              <IdentityStatement />
            </PrivateRoute>
          } />
          <Route path="/facilitator" element={
            <PrivateRoute allowedRoles={["facilitator"]}>
              <FacilitatorDashboard />
            </PrivateRoute>
          } />
          <Route path="/program-lead" element={
            <PrivateRoute allowedRoles={["program_lead"]}>
              <ProgramLeadDashboard />
            </PrivateRoute>
          } />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
